<template>
  <div
    class="scroll-content"
    :class="{'scroll-content--layout' : this.layout}"
    :style="styleObject"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ScrollContent',

    props: {
      height: {
        type: [Number, String],
        default: null,
        required: false,
      },
      minHeight: {
        type: [Number, String],
        default: null,
        required: false,
      },
      maxHeight: {
        type: [Number, String],
        default: null,
        required: false,
      },
      layout: {
        type: Boolean,
        default: false,
        required: false,
      }
    },

    data() {
      return {
        styleObject: {},
      };
    },

    created() {
      if (!this.layout) {
        if (this.height) {
          if (typeof this.height === 'number') {
            Object.assign(this.styleObject, {
              height: `${this.height}px`,
            });
          } else {
            Object.assign(this.styleObject, {
              height: this.height,
            });
          }
        }

        if (this.minHeight) {
          if (typeof this.minHeight === 'number') {
            Object.assign(this.styleObject, {
              minHeight: `${this.minHeight}px`,
            });
          } else {
            Object.assign(this.styleObject, {
              minHeight: this.minHeight,
            });
          }
        }

        if (this.maxHeight) {
          if (typeof this.maxHeight === 'number') {
            Object.assign(this.styleObject, {
              maxHeight: `${this.maxHeight}px`,
            });
          } else {
            Object.assign(this.styleObject, {
              maxHeight: this.maxHeight,
            });
          }
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/_stylebase.scss";

  .scroll-content {
    overflow-x: hidden;
    overflow-y: auto;

    &--layout {
      height: calc(100vh - #{$top-bar_height});
      max-height: calc(100vh - #{$top-bar_height});
      min-height: calc(100vh - #{$top-bar_height});
    }
  }
</style>
